(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bj-banniere-split"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function start(video) {
      if (video.dataset.bjsReady === '1') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (video.dataset.mobile === 'non' && window.matchMedia('(max-width: 749px)').matches) return;

      video.dataset.bjsReady = '1';
      video.muted = true;
      video.addEventListener(
        'playing',
        function () {
          video.classList.add('is-playing');
        },
        { once: true }
      );
      video.src = video.dataset.src;

      var lecture = video.play();
      if (lecture && lecture.catch) {
        lecture.catch(function () {});
      }
    }

    function init(root) {
      root.querySelectorAll('[data-bjs-video]').forEach(start);
    }

    if (document.readyState === 'complete') {
      init(document);
    } else {
      window.addEventListener('load', function () {
        init(document);
      });
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bj-produits"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      if (section.dataset.bjpPret === '1') return;
      section.dataset.bjpPret = '1';

      var piste = section.querySelector('[data-bjp-piste]');
      var prec = section.querySelector('[data-bjp-prec]');
      var suiv = section.querySelector('[data-bjp-suiv]');
      if (!piste || !prec || !suiv) return;

      function pas() {
        var carte = piste.querySelector('.bjp__carte');
        return carte ? carte.getBoundingClientRect().width + 24 : 300;
      }

      function etat() {
        var max = piste.scrollWidth - piste.clientWidth - 2;
        prec.hidden = piste.scrollLeft <= 2;
        suiv.hidden = max <= 0 || piste.scrollLeft >= max;
      }

      prec.addEventListener('click', function () {
        piste.scrollBy({ left: -pas() * 2, behavior: 'smooth' });
      });
      suiv.addEventListener('click', function () {
        piste.scrollBy({ left: pas() * 2, behavior: 'smooth' });
      });
      piste.addEventListener('scroll', etat, { passive: true });
      window.addEventListener('resize', etat);
      etat();
    }

    function lancer() {
      document.querySelectorAll('[data-bjp]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', lancer);
    } else {
      lancer();
    }
    document.addEventListener('shopify:section:load', lancer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bj-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function enCentimes(texte) {
      var propre = (texte || '').replace(/[^0-9,.]/g, '').replace(/\.(?=[0-9]{3})/g, '').replace(',', '.');
      var valeur = parseFloat(propre);
      return isNaN(valeur) ? null : Math.round(valeur * 100);
    }

    function enEuros(centimes) {
      return (centimes / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
    }

    function init(barre) {
      if (barre.dataset.bjstPret === '1') return;
      barre.dataset.bjstPret = '1';

      var zone = document.querySelector('.shopify-section-product-section');
      if (!zone) return;

      var bouton = barre.querySelector('[data-bjst-btn]');
      var prix = barre.querySelector('[data-bjst-prix]');
      var barrePrix = barre.querySelector('[data-bjst-barre]');
      var badge = barre.querySelector('[data-bjst-badge]');
      var eco = barre.querySelector('[data-bjst-eco]');
      var ecoMontant = barre.querySelector('[data-bjst-eco-montant]');

      function boutonPrincipal() {
        // Le sélecteur de quantité (− / +) est rangé dans le même conteneur que le
        // bouton d'ajout : on vise donc le bouton d'ajout lui-même (data-ref / name),
        // jamais « le premier bouton du bloc » (c'était le « − », désactivé à 1).
        return zone.querySelector('product-form [data-ref="add-to-cart-button"], product-form button[name="add"]');
      }

      function recopier() {
        var principal = boutonPrincipal();
        if (principal) bouton.disabled = principal.disabled;

        var source = zone.querySelector('[data-bj-prix], product-price .ppx');
        if (!source) return;
        var actuel = source.querySelector('[data-bjpx-prix], .ppx__price');
        var ancien = source.querySelector('[data-bjpx-barre]:not([hidden]), .ppx__compare:not([hidden])');
        var pastille = source.querySelector('[data-bjpx-badge]:not([hidden]), .ppx__badge:not([hidden])');
        if (actuel) prix.textContent = actuel.textContent.trim();

        var promo = Boolean(ancien);
        prix.classList.toggle('bjst__montant--promo', promo);
        barrePrix.hidden = !promo;
        badge.hidden = !(promo && pastille);
        if (promo) barrePrix.textContent = ancien.textContent.trim();
        if (promo && pastille) badge.textContent = pastille.textContent.trim();

        if (eco) {
          var a = promo ? enCentimes(ancien.textContent) : null;
          var b = actuel ? enCentimes(actuel.textContent) : null;
          eco.hidden = !(a && b && a > b);
          if (!eco.hidden) ecoMontant.textContent = enEuros(a - b);
        }
      }

      bouton.addEventListener('click', function () {
        // Soumission réelle du formulaire : un clic simulé sur le bouton principal
        // est ignoré par le formulaire du thème, requestSubmit ne l'est pas.
        var principal = boutonPrincipal();
        if (!principal || principal.disabled) return;
        var formulaire = principal.closest('form');
        if (formulaire && typeof formulaire.requestSubmit === 'function') {
          formulaire.requestSubmit(principal);
        } else {
          principal.click();
        }
      });

      new MutationObserver(recopier).observe(zone, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
      recopier();

      // Mobile : visible dès que le bouton principal n'est pas à l'écran.
      // Desktop : seulement une fois le bouton principal dépassé, pour ne pas
      // masquer le choix de l'offre en haut de page.
      // Mesure directe au défilement : fiable partout, y compris onglet en arrière-plan.
      var grandEcran = window.matchMedia('(min-width: 750px)');
      function basculer() {
        var cible = boutonPrincipal();
        if (!cible) return;
        var cadre = cible.getBoundingClientRect();
        var aLecran = cadre.bottom > 0 && cadre.top < window.innerHeight;
        var visible = grandEcran.matches ? cadre.bottom <= 0 : !aLecran;
        barre.classList.toggle('is-visible', visible);
      }

      barre.hidden = false;
      window.addEventListener('scroll', basculer, { passive: true });
      window.addEventListener('resize', basculer);
      basculer();
    }

    function lancer() {
      document.querySelectorAll('[data-bjst]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', lancer);
    } else {
      lancer();
    }
    document.addEventListener('shopify:section:load', lancer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bj-topbar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(zone) {
      if (zone.dataset.bjtPret === '1') return;
      zone.dataset.bjtPret = '1';
      var messages = zone.querySelectorAll('.bjt__message');
      if (messages.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var index = 0;
      setInterval(function () {
        messages[index].classList.remove('is-active');
        index = (index + 1) % messages.length;
        messages[index].classList.add('is-active');
      }, 5000);
    }

    // Hauteur réelle de la barre, pour caler le header fixe juste dessous.
    function mesurer() {
      var barre = document.querySelector('[data-bjt]');
      if (!barre || !barre.offsetHeight) return;
      document.documentElement.style.setProperty('--bj-topbar-h', barre.offsetHeight + 'px');
    }

    // La barre est remesurée dès que sa taille change (onglet ouvert en
    // arrière-plan, rotation du téléphone, message plus long).
    function surveiller() {
      var barre = document.querySelector('[data-bjt]');
      if (!barre || barre.dataset.bjtMesure === '1' || !('ResizeObserver' in window)) return;
      barre.dataset.bjtMesure = '1';
      new ResizeObserver(mesurer).observe(barre);
    }

    // Bandeau cookies natif de Shopify : son lien « Politique de confidentialité »
    // se règle dans l'admin (Paramètres > Confidentialité des clients). Tant
    // qu'il pointe ailleurs, on le ramène sur la page de politique du site.
    var PAGE_CONFIDENTIALITE = '/pages/politique-de-confidentialite';
    function corrigerLiensCookies() {
      document
        .querySelectorAll('#shopify-pc__banner a[href*="privacy-policy"], #shopify-pc__prefs a[href*="privacy-policy"]')
        .forEach(function (lien) {
          if (lien.getAttribute('href') !== PAGE_CONFIDENTIALITE) lien.setAttribute('href', PAGE_CONFIDENTIALITE);
        });
    }

    function surveillerCookies() {
      if (document.body.dataset.bjtCookies === '1') return;
      document.body.dataset.bjtCookies = '1';
      corrigerLiensCookies();
      // Le bandeau et la fenêtre de préférences sont ajoutés en fin de <body>.
      new MutationObserver(corrigerLiensCookies).observe(document.body, { childList: true });
    }

    function lancer() {
      surveillerCookies();
      document.querySelectorAll('[data-bjt-messages]').forEach(init);
      mesurer();
      surveiller();
    }

    window.addEventListener('resize', mesurer);

    // Fiche produit : le badge d'avis fait défiler vers la section des
    // avis de la page au lieu de la quitter.
    document.addEventListener('click', function (e) {
      var badge = e.target.closest('[data-bjt-avis]');
      if (!badge) return;
      var cible = document.querySelector('[id^="shopify-section-"][id$="__bj_avis"]');
      if (!cible) return;
      e.preventDefault();
      cible.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', lancer);
    } else {
      lancer();
    }
    document.addEventListener('shopify:section:load', lancer);
  })();

  } catch(e) { console.error(e); }
})();
})();
